import { Text } from "../../../Text/Text.js";
import { TextSize } from "../../../Text/Text.types.js";
import { Wrapper } from "./PopoverItem.style.js";
import { PopoverItemProps } from "./PopoverItem.types.js";

export const PopoverItem = ({ children, isSelected, isHighlighted, onClick, ...restProps }: PopoverItemProps) => {
    return (
        <Wrapper isSelected={isSelected} isHighlighted={isHighlighted} onClick={onClick} {...restProps}>
            {typeof children === "string" ? <Text size={TextSize["XX-SMALL"]}>{children}</Text> : children}
        </Wrapper>
    );
};
